module.exports = __webpack_public_path__ + "media/images/div_lens/div-diverse-groups-7da357ffb5c58403e846b2cc32342662.png";